import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import SubHeader from "../components/SubHeader";
import AssignTechnicianModal from "../components/modals/AssignTechnicianModal";
import { fetchMaintenanceData } from "../redux/actions/servicePresetsActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import { curSym } from "../auth/Pip";
import StatusCol from "../components/StatusCol";
import moment from "moment";
import { CreateTask } from "../redux/actions/maintainedBoatsActions";
import {
  getActiveStaffData,
  getBoatData,
  getSupplierData,
} from "../redux/actions/staffActions";
import { BASE_URL1 } from "../routes/BackendRoutes";
import { pageRoutes } from "../routes/PageRoutes";


const MaintenanceDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useLocation()?.state?.data || {};
  const { isLoading, maintananceData } = useSelector(
    (state) => state?.servicePresetsReducer,
  );

  const { isLoading1, staff_active_data, staff_dropdown_data, all_boats } =
    useSelector((state) => state?.staffReducer);

  const { isLoading2 } = useSelector(
    (state) => state?.maintainedReducer
  );

  const initialState = {
    description: "",
    time_alloted: "",
    quoted_value: "",
    boatId: "",
    assignStaffId: "",
    supplierId: "",
    date_scheduled_from: "",
    date_scheduled_to: "",
    ct_checkbox_cbx: false,
    status: false,
    completed_at: "",
    scheduled_start_time: new Date(),
  };

  const modalInitialValues = React.useMemo(() => {
    const taskObj = maintananceData || data;
    if (!taskObj) return initialState;

    let assignStaffId = "";
    let supplierId = "";

    if (taskObj.assign_to) {
      assignStaffId = taskObj.assign_to;
      if (assignStaffId === "STAFF") {
        supplierId = taskObj.assignStaffId || (taskObj.staff?.id) || "";
      } else if (assignStaffId === "OUTSOURCED") {
        if (taskObj.supplier) {
          supplierId = [{
            value: taskObj.supplier.id,
            label: taskObj.supplier.companyName || taskObj.supplier.company_name || taskObj.supplier.name || taskObj.supplier.email
          }];
        } else if (taskObj.offers && taskObj.offers.length > 0) {
          supplierId = taskObj.offers.map(o => ({
            value: o.supplierId || o.supplier?.id || o.id,
            label: o.companyName || o.company_name || o.name || o.email
          }));
        } else {
          supplierId = [];
        }
      }
    }

    return {
      description: taskObj.description || "",
      time_alloted: taskObj.time_alloted || "",
      quoted_value: taskObj.totalCost || taskObj.quoted_value || "",
      boatId: taskObj.boatId || taskObj.boatDetails?.boatId || "",
      assignStaffId: assignStaffId,
      supplierId: supplierId,
      date_scheduled_from: taskObj.date_scheduled_from
        ? taskObj.date_scheduled_from.split("T")[0]
        : "",
      date_scheduled_to: taskObj.date_scheduled_to
        ? taskObj.date_scheduled_to.split("T")[0]
        : "",
      ct_checkbox_cbx: taskObj.isRecurring == 1,
      status: false,
      completed_at: "",
      scheduled_start_time: taskObj.scheduled_start_time ? new Date(taskObj.scheduled_start_time) : new Date(),
    };
  }, [maintananceData, data]);

  const [isToggle, setIsToggle] = useState(false);
  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };
  const approvalStatus = (
    maintananceData?.ownerApprovalStatus ||
    data?.ownerApprovalStatus ||
    data?.status ||
    ""
  ).toUpperCase();
  const isAlreadyAssigned = Boolean(
    maintananceData?.assignStaffId ||
    maintananceData?.supplierId ||
    maintananceData?.assign_to === "OUTSOURCED"
  );

  const isSupplierTab = sessionStorage.getItem("servicehub_maintenance_active_tab") === "supplier";
  const taskStatus = maintananceData?.status ?? data?.status;
  const canShowAssignButton =
    !isSupplierTab &&
    ["APPROVED", "APROVED", "Approved"].includes(approvalStatus) &&
    taskStatus !== 1 &&
    taskStatus !== 4;

  // Supplier flow: data?.status = offer status, data?.taskStatus = task progress
  const offerStatus = data?.status || "";
  const supplierTaskStatus = data?.taskStatus || "";
  const isSupplierView = isSupplierTab && ["APPROVED", "APROVED", "Approved"].includes(offerStatus);



  useEffect(() => {
    dispatch(fetchMaintenanceData({ payload: data?.taskId }));
    dispatch(getBoatData());
    dispatch(getSupplierData());
    dispatch(getActiveStaffData());
  }, []);

  const onHandleCreateTask = async (values, { setSubmitting, resetForm }) => {
    console.log({ values });
    setSubmitting(false);
    resetForm();
    const callback = (response) => {
      if (response.success)
        dispatch(fetchMaintenanceData({ payload: data?.taskId }));
    };
    let data1;
    const resolvedTaskId = data?.taskId || maintananceData?.taskId;
    if (values?.assignStaffId == "STAFF") {
      data1 = {
        taskId: resolvedTaskId,
        assigned_to: values?.assignStaffId,
        description: values?.description?.trim(),
        time_alloted: `${values?.time_alloted}`,
        quoted_value: `${values?.quoted_value}`,
        boatId: values?.boatId,
        assignStaffId: values?.supplierId,
        date_scheduled_from: values?.date_scheduled_from,
        date_scheduled_to: values?.date_scheduled_to,
        isRecurring: values?.ct_checkbox_cbx == true ? 1 : 0,
        scheduled_start_time: moment(
          values?.scheduled_start_time
        )
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),
        // status: values?.completed_at ? 1 : 0,
        // completed_at: values?.completed_at,
      };
    } else if (values?.assignStaffId == "OUTSOURCED") {
      let val = [];
      values?.supplierId?.map((item) => val.push(item?.value));
      data1 = {
        taskId: resolvedTaskId,
        assigned_to: values?.assignStaffId,
        description: values?.description?.trim(),
        time_alloted: `${values?.time_alloted}`,
        quoted_value: `${values?.quoted_value}`,
        boatId: values?.boatId,
        supplierIds: val,
        date_scheduled_from: values?.date_scheduled_from,
        date_scheduled_to: values?.date_scheduled_to,
        isRecurring: values?.ct_checkbox_cbx == true ? 1 : 0,
        // status: values?.completed_at ? 1 : 0,
        // completed_at: values?.completed_at,
      };
    }
    dispatch(CreateTask({ payload: data1, callback }));
  };

  if (isLoading || isLoading2) {
    return <Loader />;
  }

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="maintenance-details" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div className="ct_dashbaord_middle">
            <div className="d-flex justify-content-between ct_flex_col_575 gap-3">
              <SubHeader />
              {canShowAssignButton && (
                <div className="ct_w_100_575">
                  <a
                    class="ct_orange_btn ct_w_100_575 px-3  flex-grow-1"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_assign_technician_modal_post"
                  >
                    <svg
                      className="me-2"
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.16667 12.1477V14.0635C8.33701 13.7702 7.44909 13.6802 6.57745 13.8011C5.70582 13.9221 4.87593 14.2504 4.15748 14.7585C3.43903 15.2666 2.85298 15.9397 2.44857 16.7213C2.04415 17.5028 1.83317 18.37 1.83333 19.25H5.27277e-07C-0.000423941 18.1306 0.255436 17.0259 0.747972 16.0206C1.24051 15.0154 1.95665 14.1362 2.8415 13.4506C3.72636 12.7649 4.75645 12.2909 5.85283 12.0649C6.94921 11.8389 8.08278 11.8678 9.16667 12.1477ZM7.33334 11C4.29458 11 1.83333 8.53875 1.83333 5.5C1.83333 2.46125 4.29458 0 7.33334 0C10.3721 0 12.8333 2.46125 12.8333 5.5C12.8333 8.53875 10.3721 11 7.33334 11ZM7.33334 9.16667C9.35917 9.16667 11 7.52583 11 5.5C11 3.47417 9.35917 1.83333 7.33334 1.83333C5.3075 1.83333 3.66667 3.47417 3.66667 5.5C3.66667 7.52583 5.3075 9.16667 7.33334 9.16667ZM12.8333 14.6667V11.9167H14.6667V14.6667H17.4167V16.5H14.6667V19.25H12.8333V16.5H10.0833V14.6667H12.8333Z"
                        fill="white"
                      />
                    </svg>
                    {isAlreadyAssigned ? "Reassign" : "Assign"}{" "}
                  </a>
                </div>
              )}
              {/* ── Supplier flow action buttons ─────────────────────────── */}
              {isSupplierView && (
                <div className="d-flex gap-2 align-items-center">
                  {(supplierTaskStatus === "ASSIGNED" || supplierTaskStatus === "UNASSIGNED") && (
                    <button
                      className="ct_orange_btn ct_w_100_575 px-3"
                      onClick={() => navigate(pageRoutes.job_service, { state: { data } })}
                      style={{ background: "#16a34a", border: "none" }}
                    >
                      ● Commence Task
                    </button>
                  )}
                  {supplierTaskStatus === "IN_PROGRESS" && (
                    <button
                      className="ct_orange_btn ct_w_100_575 px-3"
                      onClick={() => navigate(pageRoutes.mentenance_task, { state: { data } })}
                      style={{ background: "#d97706", border: "none" }}
                    >
                      ● Commenced
                    </button>
                  )}
                  {supplierTaskStatus === "COMPLETED" && (
                    <button
                      className="ct_orange_btn ct_w_100_575 px-3"
                      disabled
                      style={{ background: "#6b7280", border: "none", opacity: 0.8 }}
                    >
                      ✓ Completed
                    </button>
                  )}
                  {supplierTaskStatus === "INVOICED" && (
                    <button
                      className="ct_orange_btn ct_w_100_575 px-3"
                      disabled
                      style={{ background: "#4b5563", border: "none", opacity: 0.8 }}
                    >
                      ✓ Invoiced
                    </button>
                  )}
                </div>
              )}
            </div>

            <div class="row mt-5">
              <div class="col-xl-8">
                <div class="ct_white_bg_1 pb-5 ">
                  <div class="d-flex justify-content-between mb-4">
                    <h3 class="ct_fs_16 ct_fw_700 ct_text_dark">
                      Added Services
                    </h3>

                    {/* <!-- optinal button // ct_active_badge ct_pending_badge // --> */}
                    {/* <span class= ct_fw_600">Approved</span> */}
                    <StatusCol
                      isdot={false}
                      status={data?.status}
                      type={"maintenance"}
                    />
                    {/* <!-- <span class="ct_pending_badge">Pending</span> --> */}
                  </div>

                  <div class="maintennce-service-wrapper d-grid gap-3">
                    {maintananceData?.services?.length > 0 ? (
                      maintananceData?.services?.map((item, index) => (
                        <div class="service-row">
                          <div class="service-left">
                            <div class="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                              {item?.serviceName || "-"}
                            </div>
                            {/* <p class="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                            Complete boat haul out and inspection
                          </p> */}
                          </div>
                          <div class="service-right">
                            <div class="price-block text-center">
                              <div class="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                                PRICE
                              </div>
                              <div class="price-value ct_fs_14 ct_fw_700">
                                <span class="dollar ct_text_para">
                                  {curSym}
                                </span>
                                {item?.servicePrice || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center py-4 ct_text_para">
                        No services added.
                      </div>
                    )}
                  </div>
                </div>

                {/* Task Schedule & Info */}
                {maintananceData && (
                  <div class="ct_white_bg_1 pb-5 ct_mt_25">
                    <div class="d-flex justify-content-between mb-4">
                      <h3 class="ct_fs_16 ct_fw_700 ct_text_dark">
                        Task Schedule & Info
                      </h3>
                    </div>
                    <div className="row g-3 px-4">
                      {maintananceData.jobNumber && maintananceData.jobNumber !== "-" && (
                        <div className="col-md-6 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Job Number:</strong></p>
                          <p className="ct_text_para ct_fs_14">{maintananceData.jobNumber}</p>
                        </div>
                      )}
                      {maintananceData.time_alloted && maintananceData.time_alloted !== "0" && (
                        <div className="col-md-6 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Time Allotted:</strong></p>
                          <p className="ct_text_para ct_fs_14">{maintananceData.time_alloted} Hours</p>
                        </div>
                      )}
                      {maintananceData.date_scheduled_from && (
                        <div className="col-md-6 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Scheduled From:</strong></p>
                          <p className="ct_text_para ct_fs_14">
                            {moment(maintananceData.date_scheduled_from).format("DD-MM-YYYY")}
                          </p>
                        </div>
                      )}
                      {maintananceData.date_scheduled_to && (
                        <div className="col-md-6 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Scheduled To:</strong></p>
                          <p className="ct_text_para ct_fs_14">
                            {moment(maintananceData.date_scheduled_to).format("DD-MM-YYYY")}
                          </p>
                        </div>
                      )}
                      {maintananceData.description && (
                        <div className="col-12 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Description:</strong></p>
                          <p className="ct_text_para ct_fs_14" style={{ whiteSpace: "pre-wrap" }}>
                            {maintananceData.description}
                          </p>
                        </div>
                      )}
                      {maintananceData.taskInfo && (
                        <div className="col-12">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Task Info:</strong></p>
                          <p className="ct_text_para ct_fs_14" style={{ whiteSpace: "pre-wrap" }}>
                            {maintananceData.taskInfo}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Job Service Sheet Details */}
                {maintananceData?.jobSheet && (
                  <div className="ct_white_bg_1 pb-5 ct_mt_25">
                    <div className="d-flex justify-content-between mb-4">
                      <h3 className="ct_fs_16 ct_fw_700 ct_text_dark">
                        Job Execution Details (Service Sheet)
                      </h3>
                    </div>
                    <div className="row g-3 px-4">
                      {maintananceData.jobSheet.personAttending && (
                        <div className="col-md-6 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Person Attending:</strong></p>
                          <p className="ct_text_para ct_fs_14">{maintananceData.jobSheet.personAttending}</p>
                        </div>
                      )}
                      {maintananceData.jobSheet.workCarriedOut && (
                        <div className="col-12 mb-3">
                          <p className="mb-1 ct_fs_14"><strong className="ct_text_dark">Work Carried Out:</strong></p>
                          <p className="ct_text_para ct_fs_14" style={{ whiteSpace: "pre-wrap" }}>
                            {maintananceData.jobSheet.workCarriedOut}
                          </p>
                        </div>
                      )}

                      {/* Inventory Parts Used */}
                      {maintananceData.jobSheet.boatParts?.length > 0 && (
                        <div className="col-12 mb-3">
                          <p className="mb-2 ct_fs_14"><strong className="ct_text_dark">Inventory Parts Installed:</strong></p>
                          <div className="table-responsive">
                            <table className="table table-bordered ct_custom_table">
                              <thead>
                                <tr>
                                  <th>Part Name</th>
                                  <th style={{ width: "100px" }}>Quantity</th>
                                  <th style={{ width: "120px" }}>Price Per Unit</th>
                                  <th>Total Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {maintananceData.jobSheet.boatParts.map((item, idx) => {
                                  const price = Number(item.boatOwnerCost || 0);
                                  const total = price * Number(item.quantity || 0);
                                  return (
                                    <tr key={idx}>
                                      <td>{item.partName}</td>
                                      <td>{item.quantity}</td>
                                      <td>{curSym}{price.toFixed(2)}</td>
                                      <td>{curSym}{total.toFixed(2)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      {/* Manual Materials Used */}
                      {maintananceData.jobSheet.materials?.length > 0 && (
                        <div className="col-12 mb-3">
                          <p className="mb-2 ct_fs_14"><strong className="ct_text_dark">Materials & Consumables Used:</strong></p>
                          <div className="table-responsive">
                            <table className="table table-bordered ct_custom_table">
                              <thead>
                                <tr>
                                  <th>Material Name</th>
                                  <th style={{ width: "100px" }}>Quantity</th>
                                  <th style={{ width: "120px" }}>Price Per Unit</th>
                                  <th>Total Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {maintananceData.jobSheet.materials.map((item, idx) => {
                                  const price = Number(item.pricePerUnit || 0);
                                  const total = Number(item.totalPrice || (price * Number(item.unitsUsed || 0)));
                                  return (
                                    <tr key={idx}>
                                      <td>{item.materialName}</td>
                                      <td>{item.unitsUsed}</td>
                                      <td>{curSym}{price.toFixed(2)}</td>
                                      <td>{curSym}{total.toFixed(2)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      {/* Task Photos */}
                      {maintananceData.taskPhotos?.length > 0 && (
                        <div className="col-12 mb-3">
                          <p className="mb-2 ct_fs_14"><strong className="ct_text_dark">Job Photos:</strong></p>
                          <div className="d-flex flex-wrap gap-3">
                            {maintananceData.taskPhotos.map((photo) => (
                              <div key={photo.id} style={{ position: "relative" }}>
                                <img
                                  src={photo.url}
                                  alt="Job Progress"
                                  className="rounded border"
                                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Signature */}
                      {maintananceData.jobSheet.cdsSignature && (
                        <div className="col-12">
                          <p className="mb-2 ct_fs_14"><strong className="ct_text_dark">Technician Signature:</strong></p>
                          <div className="border rounded bg-light p-2" style={{ width: "fit-content" }}>
                            <img
                              src={maintananceData.jobSheet.cdsSignature}
                              alt="Technician Signature"
                              style={{ maxHeight: "80px", maxWidth: "300px" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div class="col-xl-4 mt-xl-0 mt-4">
                <div class="">
                  <div class="ct_white_bg ct_dash_card active">
                    <div class="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p class="mb-0 ct_fs_16 ct_fw_700">Total Amount</p>
                      </div>
                    </div>
                    <h3 class="ct_fw_800 ct_fs_24 ct_ff_ProximaNova_bold mb-1 ct_black_text mt-2">
                      {curSym}{maintananceData?.totalCost}
                    </h3>

                    <h6 class="text-white ct_fs_12 ct_fw_400 mb-0 ">
                      Estimated (Excl. Tax)
                    </h6>
                  </div>

                  <div class="ct_white_bg_1 ct_mt_25">
                    <h3 class="ct_fs_14 ct_fw_700 ct_text_dark mb-4">
                      <svg
                        class="me-2"
                        width="18"
                        height="21"
                        viewBox="0 0 18 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 21L6 18H2C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H12L9 21ZM9 10C9.96667 10 10.7917 9.65833 11.475 8.975C12.1583 8.29167 12.5 7.46667 12.5 6.5C12.5 5.53333 12.1583 4.70833 11.475 4.025C10.7917 3.34167 9.96667 3 9 3C8.03333 3 7.20833 3.34167 6.525 4.025C5.84167 4.70833 5.5 5.53333 5.5 6.5C5.5 7.46667 5.84167 8.29167 6.525 8.975C7.20833 9.65833 8.03333 10 9 10ZM2 16H16C16 15.95 16 15.7583 16 15.425C16 15.0917 16 14.9 16 14.85C15.1 13.9667 14.0542 13.2708 12.8625 12.7625C11.6708 12.2542 10.3833 12 9 12C7.61667 12 6.32917 12.2542 5.1375 12.7625C3.94583 13.2708 2.9 13.9667 2 14.85C2 14.9 2 15.0917 2 15.425C2 15.7583 2 15.95 2 16Z"
                          fill="#2F3849"
                        />
                      </svg>
                      OWNER DETAILS
                    </h3>
                    <div class="maintenance_det-owner_det mb-4">
                      <div class="icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 8.33366C10.3283 8.33366 10.6534 8.26899 10.9567 8.14336C11.26 8.01772 11.5356 7.83357 11.7678 7.60143C11.9999 7.36928 12.1841 7.09368 12.3097 6.79037C12.4353 6.48705 12.5 6.16196 12.5 5.83366C12.5 5.50535 12.4353 5.18026 12.3097 4.87695C12.1841 4.57364 11.9999 4.29804 11.7678 4.06589C11.5356 3.83375 11.26 3.6496 10.9567 3.52396C10.6534 3.39832 10.3283 3.33366 10 3.33366C9.33696 3.33366 8.70107 3.59705 8.23223 4.06589C7.76339 4.53473 7.5 5.17062 7.5 5.83366C7.5 6.4967 7.76339 7.13259 8.23223 7.60143C8.70107 8.07027 9.33696 8.33366 10 8.33366ZM10 10.0003C11.1051 10.0003 12.1649 9.56134 12.9463 8.77994C13.7277 7.99854 14.1667 6.93873 14.1667 5.83366C14.1667 4.72859 13.7277 3.66878 12.9463 2.88738C12.1649 2.10598 11.1051 1.66699 10 1.66699C8.89493 1.66699 7.83512 2.10598 7.05372 2.88738C6.27232 3.66878 5.83333 4.72859 5.83333 5.83366C5.83333 6.93873 6.27232 7.99854 7.05372 8.77994C7.83512 9.56134 8.89493 10.0003 10 10.0003ZM3.86583 12.8737C4.82 11.6087 6.2575 10.8337 8.095 10.8337H11.905C13.7425 10.8337 15.18 11.6087 16.1342 12.8737C17.0683 14.1128 17.5 15.7637 17.5 17.5003C17.5 17.7213 17.4122 17.9333 17.2559 18.0896C17.0996 18.2459 16.8877 18.3337 16.6667 18.3337C16.4457 18.3337 16.2337 18.2459 16.0774 18.0896C15.9211 17.9333 15.8333 17.7213 15.8333 17.5003C15.8333 16.0153 15.4617 14.7503 14.8042 13.877C14.1667 13.032 13.2225 12.5003 11.9042 12.5003H8.09583C6.7775 12.5003 5.83333 13.032 5.19583 13.877C4.5375 14.7503 4.16667 16.0153 4.16667 17.5003C4.16667 17.7213 4.07887 17.9333 3.92259 18.0896C3.76631 18.2459 3.55435 18.3337 3.33333 18.3337C3.11232 18.3337 2.90036 18.2459 2.74408 18.0896C2.5878 17.9333 2.5 17.7213 2.5 17.5003C2.5 15.7637 2.93167 14.1128 3.86583 12.8737Z"
                            fill="#23C0E8"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.5 17.5003C2.5 17.2793 2.5878 17.0673 2.74408 16.9111C2.90036 16.7548 3.11232 16.667 3.33333 16.667H16.635C16.856 16.667 17.068 16.7548 17.2243 16.9111C17.3805 17.0673 17.4683 17.2793 17.4683 17.5003C17.4683 17.7213 17.3805 17.9333 17.2243 18.0896C17.068 18.2459 16.856 18.3337 16.635 18.3337H3.33333C3.11232 18.3337 2.90036 18.2459 2.74408 18.0896C2.5878 17.9333 2.5 17.7213 2.5 17.5003Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>
                      <div>
                        <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                          DIRECTOR
                        </h6>
                        <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                          {maintananceData?.boatDetails?.ownerName || "-"}
                        </h6>
                      </div>
                    </div>
                    <div class="maintenance_det-owner_det mb-4">
                      <div class="icon">
                        <svg
                          width="17"
                          height="14"
                          viewBox="0 0 17 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.66667 13.3333C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H15C15.4583 0 15.8507 0.163194 16.1771 0.489583C16.5035 0.815972 16.6667 1.20833 16.6667 1.66667V11.6667C16.6667 12.125 16.5035 12.5174 16.1771 12.8438C15.8507 13.1701 15.4583 13.3333 15 13.3333H1.66667ZM8.33333 7.5L1.66667 3.33333V11.6667H15V3.33333L8.33333 7.5ZM8.33333 5.83333L15 1.66667H1.66667L8.33333 5.83333ZM1.66667 3.33333V1.66667V3.33333V11.6667V3.33333Z"
                            fill="#23C0E8"
                          />
                        </svg>
                      </div>
                      <div>
                        <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                          EMAIL ADDRESS
                        </h6>
                        <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                          {maintananceData?.boatDetails?.ownerEmail ||
                            maintananceData?.boatDetails?.email ||
                            "-"}
                        </h6>
                      </div>
                    </div>
                    <div class="maintenance_det-owner_det">
                      <div class="icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_291_10786)">
                            <path
                              d="M3.83312 15.0556C4.44423 15 5.05534 15.2222 5.55534 15.6667C6.16645 16.2778 7.16645 16.2778 7.83312 15.6667C8.38867 15.2778 8.99978 15.0556 9.66645 15.0556C10.3331 15 10.9998 15.2222 11.4998 15.6667C11.8331 15.9444 12.222 16.1111 12.6665 16.1111C13.1109 16.1111 13.4998 15.9444 13.8331 15.6667C14.3887 15.2222 15.0553 15 15.722 15C16.3887 15 17.0553 15.2222 17.6109 15.6667C17.9442 15.9444 18.4442 16.1111 18.8887 16.1111V17.2222C18.1664 17.2778 17.4442 17.0556 16.8887 16.5556C16.5553 16.2778 16.0553 16.1111 15.6109 16.1111C15.222 16.1111 14.7776 16.2778 14.4442 16.5556C13.4442 17.4444 11.8887 17.4444 10.8331 16.5556C10.4998 16.2778 10.1109 16.1111 9.66645 16.1111C9.27756 16.1111 8.88867 16.2778 8.55534 16.5556C7.49978 17.4444 5.99978 17.4444 4.94423 16.5556C4.66645 16.2778 4.22201 16.1111 3.83312 16.1111C3.44423 16.1111 3.05534 16.2778 2.77756 16.5556C2.27756 16.9444 1.72201 17.1667 1.1109 17.2222V16.1111C1.66645 16.1111 1.77756 15.8889 2.05534 15.6667C2.55534 15.2778 3.16645 15.0556 3.83312 15.0556Z"
                              fill="#23C0E8"
                            />
                            <path
                              d="M16.6671 12.778C16.6671 12.4447 16.3893 12.2224 16.056 12.2224H2.22265L4.1671 13.9447H4.05599C3.61154 13.9447 3.1671 14.0558 2.83376 14.2224L1.44487 13.0002L1.33377 12.8891C0.944876 12.4447 1.00043 11.7224 1.44487 11.3336C1.6671 11.2224 1.88932 11.1113 2.1671 11.1113H16.056C17.0004 11.1113 17.7227 11.8336 17.7227 12.778V14.5558C17.4449 14.278 17.056 14.1113 16.6671 13.9447V12.778Z"
                              fill="#23C0E8"
                            />
                            <path
                              d="M15.0559 10.5557H11.667V6.22235C11.667 5.88902 11.8337 5.55568 12.1114 5.33346C12.6114 4.94457 13.3337 5.05568 13.667 5.55568L15.9448 8.83346C16.167 9.16679 16.167 9.61124 16.0003 10.0001C15.8337 10.3335 15.4448 10.5557 15.0559 10.5557ZM12.7226 6.22235L12.7781 9.44457H15.0559L12.7226 6.22235Z"
                              fill="#23C0E8"
                            />
                            <path
                              d="M5.55577 10.0001C5.33355 9.66678 5.33355 9.22233 5.55577 8.889L9.05577 3.11122C9.27799 2.77789 9.61133 2.55566 10.0002 2.55566C10.6113 2.55566 11.1113 3.05566 11.1113 3.66678V10.5557H6.50022C6.11133 10.5557 5.72244 10.3334 5.55577 10.0001ZM10.0558 3.66678L6.50022 9.50011H10.0558V3.66678Z"
                              fill="#23C0E8"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_291_10786">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="matrix(-1 0 0 1 20 0)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div>
                        <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                          Boat Name AND NO.
                        </h6>
                        <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                          {maintananceData?.boatDetails?.boatName || "-"}{" "}
                          <span class="ms-2 ct_fs_14 ct_fw_400 ct_text_para">
                            {maintananceData?.boatDetails?.rego || "-"}
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>

                  {/* Assignment Details */}
                  <div class="ct_white_bg_1 ct_mt_25">
                    <h3 class="ct_fs_14 ct_fw_700 ct_text_dark mb-4">
                      <i className="fa-solid fa-user-check me-2 ct_clr_blue_dark"></i>
                      ASSIGNMENT DETAILS
                    </h3>

                    {/* STAFF assignment */}
                    {maintananceData?.assign_to === "STAFF" ? (
                      maintananceData?.staff ? (
                        <div>
                          <div class="maintenance_det-owner_det mb-4">
                            <div class="icon">
                              <i className="fa-solid fa-user-tie text-info fs-5"></i>
                            </div>
                            <div>
                              <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                                TECHNICIAN / STAFF MEMBER
                              </h6>
                              <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                {maintananceData.staff.full_name || maintananceData.staff.name || "-"}
                              </h6>
                            </div>
                          </div>
                          {(maintananceData.staff.email || maintananceData.staff.email) && (
                            <div class="maintenance_det-owner_det mb-4">
                              <div class="icon">
                                <i className="fa-solid fa-envelope text-info fs-5"></i>
                              </div>
                              <div>
                                <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                                  EMAIL ADDRESS
                                </h6>
                                <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                  {maintananceData.staff.email || "-"}
                                </h6>
                              </div>
                            </div>
                          )}
                          {maintananceData.staff.phone_no || maintananceData.staff.phone ? (
                            <div class="maintenance_det-owner_det">
                              <div class="icon">
                                <i className="fa-solid fa-phone text-info fs-5"></i>
                              </div>
                              <div>
                                <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                                  PHONE NUMBER
                                </h6>
                                <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                  {maintananceData.staff.phone_no || maintananceData.staff.phone || "-"}
                                </h6>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-2 text-muted">
                          <i className="fa-solid fa-user-tie fs-5 text-info"></i>
                          <span>Assigned to Technician (details not available)</span>
                        </div>
                      )

                      /* OUTSOURCED assignment */
                    ) : maintananceData?.assign_to === "OUTSOURCED" ? (
                      <div>
                        {/* Accepted supplier shown */}
                        {maintananceData?.supplier ? (
                          <div>
                            <div class="maintenance_det-owner_det mb-4">
                              <div class="icon">
                                <i className="fa-solid fa-handshake text-info fs-5"></i>
                              </div>
                              <div>
                                <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                                  SUPPLIER (ACCEPTED)
                                </h6>
                                <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                  {maintananceData.supplier.company_name || maintananceData.supplier.companyName || maintananceData.supplier.name || (maintananceData.supplier.first_name + " " + maintananceData.supplier.last_name).trim() || "-"}
                                </h6>
                              </div>
                            </div>
                            {maintananceData.supplier.email && (
                              <div class="maintenance_det-owner_det mb-4">
                                <div class="icon">
                                  <i className="fa-solid fa-envelope text-info fs-5"></i>
                                </div>
                                <div>
                                  <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                                    EMAIL ADDRESS
                                  </h6>
                                  <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                    {maintananceData.supplier.email}
                                  </h6>
                                </div>
                              </div>
                            )}
                            {(maintananceData.supplier.phone_no || maintananceData.supplier.phone) && (
                              <div class="maintenance_det-owner_det">
                                <div class="icon">
                                  <i className="fa-solid fa-phone text-info fs-5"></i>
                                </div>
                                <div>
                                  <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-1">
                                    PHONE NUMBER
                                  </h6>
                                  <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                    {maintananceData.supplier.phone_no || maintananceData.supplier.phone}
                                  </h6>
                                </div>
                              </div>
                            )}
                          </div>

                          /* Offers list (pending approval) */
                        ) : maintananceData?.offers && maintananceData.offers.length > 0 ? (
                          <div>
                            <h6 class="ct_text_para ct_fs_12 ct_fw_700 text-capitalize mb-3">
                              SENT TO SUPPLIERS (PENDING APPROVAL)
                            </h6>
                            {maintananceData.offers.map((offer, idx) => (
                              <div key={offer.id} className={`maintenance_det-owner_det ${idx < maintananceData.offers.length - 1 ? "mb-3" : ""}`}>
                                <div class="icon">
                                  <i className="fa-solid fa-clock-rotate-left text-warning fs-5"></i>
                                </div>
                                <div>
                                  <h6 class="ct_text_dark ct_fw_700 ct_fs_16 mb-0">
                                    {offer.companyName || offer.company_name || offer.email || "-"}
                                  </h6>
                                  <span className="badge bg-secondary mt-1">{offer.status}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-2 text-muted">
                            <i className="fa-solid fa-handshake fs-5 text-info"></i>
                            <span>Outsourced — awaiting supplier response</span>
                          </div>
                        )}
                      </div>

                      /* No assignment */
                    ) : (
                      <div className="d-flex align-items-center gap-2 text-muted">
                        <i className="fa-solid fa-circle-exclamation text-warning fs-5"></i>
                        <span>Not assigned to any technician or supplier.</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AssignTechnicianModal
        modalId="ct_assign_technician_modal_post"
        title="Assign Technician/Supplier"
        initialValues={modalInitialValues}
        onSubmit={(values, actions) => onHandleCreateTask(values, actions)}
        allBoats={all_boats}
        staffActiveData={staff_active_data}
        staffDropdownData={staff_dropdown_data}
      />
    </div>
  );
};

export default MaintenanceDetails;
